import { useEffect } from "react";

declare global {
	interface Window {
		oaiq?: any;
	}
}

/**
 * Initialize the ChatGPT (OpenAI) conversion pixel only when REACT_APP_CHATGPT_PIXEL_ID is set
 */
const useChatGptPixel = (): void => {
	useEffect(() => {
		const pixelId = process.env.REACT_APP_CHATGPT_PIXEL_ID;

		if (!pixelId) {
			console.log("ChatGPT Pixel disabled (no ID)");
			return;
		}

		if (window.oaiq) {
			return;
		}

		(function (w: any, d: Document, s: string, u: string) {
			if (w.oaiq) return;
			const q: any = function (...args: any[]) {
				q.q.push(args);
			};
			q.q = [];
			w.oaiq = q;
			const script: any = d.createElement(s);
			script.async = true;
			script.src = u;
			const firstScript = d.getElementsByTagName(s)[0];
			firstScript?.parentNode?.insertBefore(script, firstScript);
		})(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");

		window.oaiq("init", { pixelId, debug: process.env.NODE_ENV === "development" });

		console.log(`✅ ChatGPT Pixel initialized: ${pixelId}`);
	}, []);
};

export default useChatGptPixel;
